import button from "assets/stylesheets/modules/components/button.module.scss";

const Input = {
  sizes: {
    sm: {
      field: {
        h: 10,
      },
    },
    md: {
      field: {
        borderRadius: button.borderRadius,
      },
    },
    lg: {
      field: {
        h: 15,
      },
    },
  },
  variants: {
    outline: {
      field: {
        color: "gray.700",
        borderColor: "gray.400",
        _hover: {
          borderColor: "gray.500",
        },
        _focus: {
          borderColor: "gray.700",
          boxShadow: "none",
        },
      },
      addon: {
        bg: "var(--chakra-colors-muted)",
      },
    },
  },
};

export default Input;
